(ns iris.styles.simple-modal
  (:require
;;    [herb.core :refer [<class <id]]
   ;; [garden.units :refer [px]]
   [shadow.css :refer [css]]
   ))



(def $modal
  (css {:display "block"
        :position "fixed"
        :z-index "100001"
        :left "0"
        :top "0"
        :width "100%"
        :height "100%"
        :overflow "auto"
        :background-color "rgba(0,0,0,0.42)"}))


(def $modal-content
  (css {:position "absolute"
        :top "50%"
        :left "50%"
        :transform "translate(-50%, -50%)"
        :width "90%"
        :max-height "90%"
        :overflow-y "auto"
        :background-color "var(--iris-surface)"
        :color "var(--iris-text)"
        :padding "0"
        :border "1px solid var(--iris-border)"
        :border-radius "6px"
        :box-shadow "0 18px 48px rgba(0,0,0,0.28)"}
       ["@media (max-width: 640px)" {:width "calc(100% - 28px)"
                                     :max-height "calc(100% - 28px)"}]))

;; The Close Button
(def $close-btn
  (css {:align-items "center"
        :color "var(--iris-text-muted)"
        :display "flex"
        :float "right"
        :font-size "22px"
        :font-weight "bold"
        :height "44px"
        :justify-content "center"
        :line-height "1"
        :width "40px"
        :text-align "center"
        :border-left "solid 1px var(--iris-border)"}
       [:hover {:color "var(--iris-text)"
                :text-decoration "none"
                :cursor "pointer"}]))

(def $top-bar
  (css {:height "44px"
        :border-bottom "solid 1px var(--iris-border)"
        :background-color "var(--iris-surface-alt)"
        :text-align "center"}))

(def $title
  (css {:display "inline-block"
        :font-size "16px"
        :line-height "44px"
        :font-weight "bold"
        :color "var(--iris-text)"}))

(def $child-content
  (css {:padding "16px"}))

;; The Modal (background)
;; (defn modal [display]
;;   {:display (if (true? display) "block" "none")
;;    :position "fixed"
;;    :z-index "100001"
;;    :left 0
;;    :top 0
;;    :width "100%"
;;    :height "100%"
;;    :overflow "auto"
;; ;;    :background-color "rgb(0,0,0)"
;;    :background-color "rgba(0,0,0,0.4)"})

;; Modal Content/Box
;; (defn modal-content [width]
;;   {:position "absolute"
;;    :top "50%"
;;    :left "50%"
;;    :transform "translate(-50%, -50%)"
;;    :width "90%"
;;    :max-width (str width "px")
;;    :max-height "90%"
;;    :overflow-y "auto"
;;    :background-color "#fefefe"
;;    :padding 0
;;    :border "1px solid #888"})


;; The Close Button
;; (defn close-btn []
;;   ^{:pseudo {:hover {:color "black"
;;                      :text-decoration "none"
;;                      :cursor "pointer"}}}
;;   {:line-height "normal"
;;    :color "#aaa"
;;    :float "right"
;;    :font-size "28px"
;;    :font-weight "bold"
;;    :width "40px"
;;    :height "100%"
;;    :text-align "center"
;;    :border-left "solid 1px lightgrey"})


;; (defn top-bar []
;;   {:height "40px"
;;    :border "solid 1px lightgrey"
;;    :background-color "#f1f1f1"
;;    :text-align "center"})


;; (defn title []
;;   {:display "inline-block"
;;    :line-height "40px"
;;    :font-weight "bold"
;;    :color "#333"})


;; (defn child-content []
;;   {:padding "15px"})
